module.exports = __webpack_public_path__ + "img/avatar.d03b6870.svg";